/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Notetaker_RecommendedInputs */



/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Onboarding_Notetaker_RecommendedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_notetaker_recommended = /** @type {((inputs?: Onboarding_Notetaker_RecommendedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Notetaker_RecommendedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Aanbevolen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recommandé")
	return /** @type {LocalizedString} */ ("Recommended")
});